<script>
import Forms from '@/components/forms'
import { mapGetters } from 'vuex'

export default {
  name: 'add-to-cart-form',
  props: {
    productId: {
      type: String,
      required: true
    },
    product: {
      type: Object,
      default: () => {}
    },
    hideQuantity: {
      type: Boolean,
      default: false
    },
    buttonSize: {
      type: String,
      default: 'sm'
    }
  },
  data: () => ({
    quantity: 1,
    showCustomForm: false,
    specifications: {}
  }),
  computed: {
    ...mapGetters('auth', ['userProfile', 'needsCustomerStep', 'resolveCustomerAccountId']),
    customForm () {
      const { webshop_custom_form } = this.product
      if (
        Object.prototype.hasOwnProperty.call(Forms, webshop_custom_form) &&
        Forms[webshop_custom_form].component
      )
        return Forms[webshop_custom_form].component
      return null
    }
  },
  methods: {
    async onAddToCartHandler () {
      if (this.customForm !== null) {
        this.specifications = {
          ...this.specifications,
          item_id: this.product.id
        }
        this.showCustomForm = true
      } else {
        this.addToCart()
      }
    },
    onCancel () {
      this.showCustomForm = false
      this.specifications = {}
    },
    onCustomFormComplete (data) {
      this.showCustomForm = false
      this.specifications = data
      this.addToCart()
    },
    async addToCart () {
      let { web_shop_allow_grouping = false, webshop_custom_form } =
        this.product

      const {
        reference,
        file_id,
        shipping_address_id,
        comments,
        specs = {}
      } = this.specifications

      const customer_account_id = this.resolveCustomerAccountId(this.specifications)

      if (!customer_account_id) {
        this.$root.$bvToast.toast('Please select a customer before adding to cart.', {
          title: 'Customer required',
          solid: true,
          variant: 'danger',
          autoHideDelay: 3000,
          appendToast: true,
          toaster: 'b-toaster-top-center'
        })
        return
      }

      await this.$store.dispatch('cart/addToCart', {
        data: {
          ...this.specifications,
          type: webshop_custom_form,
          item_id: this.productId,
          quantity: this.quantity,
          allow_grouping: webshop_custom_form ? false : web_shop_allow_grouping,
          form_data: { ...specs },
          reference,
          file_id,
          shipping_address_id,
          customer_account_id,
          comments
        }
      })
      this.specifications = {}
      this.$root.$bvToast.toast(`Item added to Cart.`, {
        title: 'Item Added',
        solid: true,
        variant: 'info',
        autoHideDelay: 1000,
        appendToast: true,
        toaster: 'b-toaster-top-center',
        noCloseButton: true
      })
    }
  }
}
</script>
<template>
  <b-row alignH="center" align-v="center">
    <b-form-group
      label="Quantity"
      label-for="quantity"
      class="m-0 mr-1"
      v-if="!hideQuantity"
    >
      <b-form-input
        id="quantity"
        v-model.number="quantity"
        type="text"
        autocomplete="quantity"
        class="text-center"
        :style="{ maxWidth: '80px' }"
        @focus="$event.target.select()"
      ></b-form-input>
    </b-form-group>

    <b-btn
      :size="buttonSize"
      variant="secondary"
      class="btn-label mt-auto"
      style="max-height: 37px"
      v-on:click="onAddToCartHandler"
    >
      <i class="bx bx-cart label-icon"></i
      ><span class="text-truncate">{{ $t('add to cart') }}</span>
    </b-btn>

    <b-modal
      v-model="showCustomForm"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      size="lg"
      hide-footer
      hide-header
      body-class="p-2"
    >
      <h6
        class="px-3 py-2 pb-3mb-1 font-weight-light border-bottom border-light"
      >
        {{ product.short_description }}
      </h6>
      <component
        :is="customForm"
        v-model="specifications"
        v-on:complete="onCustomFormComplete"
        v-on:cancel="showCustomForm = false"
        v-if="showCustomForm"
      />
    </b-modal>
  </b-row>
</template>
